import { makeVar } from '@apollo/client';

export type ValidationCodeStatusType = undefined | 'valid' | 'invalid';

export const platformValidationCodeReactiveVar = makeVar<ValidationCodeStatusType>(undefined);
